import React, {Component} from 'react'

import * as d3 from "d3";

export default class Bars extends Component {
    constructor(props) {
        super(props);


        this.colors={
            selected: "#3182bd",
            hovered: "orange",
            default: "#3182bd"
        };

        this.getWidth = this.getWidth.bind(this);
    }


    getFillColor(val){

        /*if(val === this.props.selectedData.d){return this.colors.selected}
        else{return this.colors.default}*/

        if(this.props.color === "default")
        {
            if(this.props.hovering){
                if(val === this.props.hoveredData.d){return this.colors.hovered}
                else {
                    if (this.props.clicked) {
                        if (Array.isArray(this.props.selectedData) && this.props.selectedData.includes(val) ) {
                            return this.colors.selected
                        }
                        else if(typeof this.props.selectedData=== "string" && val===this.props.selectedData ){
                            return this.colors.selected
                        }else {
                            return this.colors.default
                        }
                    }
                    else {
                        if (Array.isArray(this.props.selectedData) && this.props.selectedData.includes(val) ) {
                            return this.colors.selected
                        }
                        else{
                            return this.colors.default
                        }

                    }
                }
            }
            else{
                if(this.props.clicked){
                    if(val === this.props.selectedData){return this.colors.selected}
                    else{return this.colors.default}
                }
                else{
                    if (Array.isArray(this.props.selectedData) && this.props.selectedData.includes(val) ) {
                        return this.colors.selected
                    }
                    else if(typeof this.props.selectedData=== "string" && val===this.props.selectedData ){
                        return this.colors.selected
                    }else {
                        return this.colors.default
                    }
                }
            }
        }
        else{

        }

    }

    getWidth(val){
        const { scales, margins, data, initData, svgDimensions } = this.props;
        const { xScale, yScale } = scales;
        //const { height,width } = svgDimensions;
        let scaledVal = xScale(val);
        return scaledVal - margins.left;

    }

    render() {
        const { scales, margins, data, initData, svgDimensions } = this.props;
        const { xScale, yScale } = scales;
        const { height,width } = svgDimensions;

        let self = this;
        let bar_h = d3.min([20,yScale.bandwidth()]);


        const bars = (
            data.map(datum =>
                <rect
                    //style={{cursor:"pointer"}}
                    //key={datum.d}
                    x={margins.left}
                    y={yScale(datum.d) + (yScale.bandwidth() - bar_h)/2}
                    height={bar_h}
                    width={self.getWidth(datum.value)}
                    fill={this.getFillColor(datum.d)}
                    onMouseOver={() => this.props.onMouseOverCallback(datum)}
                    onMouseOut={() => this.props.onMouseOutCallback(null)}
                    onClick={() => this.props.onMouseClickCallback(datum)}
                />
            )
        );


       /* const labels = (data.map(datum=>
            <text
                x={margins.left}
                y={yScale(datum.d) + yScale.bandwidth()}>{datum.d}</text>));*/

        const bars_all = (
            initData.map(datum =>
                <rect
                    //style={{cursor:"pointer"}}
                    x={margins.left}
                    y={yScale(datum.d) + (yScale.bandwidth() - bar_h)/2}
                    height={bar_h}
                    width={self.getWidth(datum.value)}
                    fill={"#cccccc"}
                    onMouseOver={() => this.props.onMouseOverCallback(datum)}
                    onMouseOut={() => this.props.onMouseOutCallback(null)}
                    onClick={() => this.props.onMouseClickCallback(datum)}
                />
            )
        );




        return (
            <g>
                {bars_all}
                {bars}
                {/* {labels}*/}
            </g>
        )
    }
}